import Api from "../../../config/api";
import {
  CREATE_LEAVE,
  DELETE_LEAVE_BY_ID,
  SEARCH_LEAVE,
  UPDATE_LEAVE,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getLeave = async (params: any) => {
  try {
    const res = await Api(false).get(SEARCH_LEAVE, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createLeave = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_LEAVE, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateLeave = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_LEAVE}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const deleteLeaveById = async (id?: string) => {
  try {
    const res = await Api(false).delete(`${DELETE_LEAVE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};
